import React, { useState } from 'react';
import './TicTacToeGame.css';

const TicTacToeGame = () => {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [isXNext, setIsXNext] = useState(true);
  const [winner, setWinner] = useState(null);
  const [isGameStarted, setIsGameStarted] = useState(false);

  const calculateWinner = (squares) => {
    const lines = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [2, 4, 6],
    ];

    for (let i = 0; i < lines.length; i++) {
      const [a, b, c] = lines[i];
      if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
        return squares[a];
      }
    }

    if (squares.every(square => square !== null)) {
      return 'draw';
    }

    return null;
  };

  const handleClick = (index) => {
    if (board[index] || winner || !isGameStarted) return;

    const newBoard = board.slice();
    newBoard[index] = isXNext ? 'X' : 'O';
    setBoard(newBoard);
    setIsXNext(!isXNext);

    const gameWinner = calculateWinner(newBoard);
    if (gameWinner) {
      setWinner(gameWinner);
    }
  };

  const resetGame = () => {
    setBoard(Array(9).fill(null));
    setIsXNext(true);
    setWinner(null);
    setIsGameStarted(false);
  };

  const startGame = () => {
    setIsGameStarted(true);
    setBoard(Array(9).fill(null));
    setIsXNext(true);
    setWinner(null);
  };

  const renderSquare = (index) => {
    return (
      <button
        className={`square ${board[index] ? `square-${board[index].toLowerCase()}` : ''}`}
        onClick={() => handleClick(index)}
        disabled={!!board[index] || !!winner || !isGameStarted}
      >
        {board[index]}
      </button>
    );
  };

  const getStatus = () => {
    if (!isGameStarted) {
      return 'Click Start to Play!';
    }
    if (winner === 'X') {
      return '🎉 X Wins!';
    }
    if (winner === 'O') {
      return '🎉 O Wins!';
    }
    if (winner === 'draw') {
      return '🤝 It\'s a Draw!';
    }
    return `Next: ${isXNext ? 'X' : 'O'}`;
  };

  return (
    <div className="tic-tac-toe-container">
      <div className="tic-tac-toe-header">
        <h2>⭕❌ Tic-Tac-Toe</h2>
        <div className="game-status">{getStatus()}</div>
      </div>

      <div className="board">
        <div className="board-row">
          {renderSquare(0)}
          {renderSquare(1)}
          {renderSquare(2)}
        </div>
        <div className="board-row">
          {renderSquare(3)}
          {renderSquare(4)}
          {renderSquare(5)}
        </div>
        <div className="board-row">
          {renderSquare(6)}
          {renderSquare(7)}
          {renderSquare(8)}
        </div>
      </div>

      <div className="game-controls-ttt">
        {!isGameStarted ? (
          <button onClick={startGame} className="game-btn start-btn">
            Start Game
          </button>
        ) : (
          <button onClick={resetGame} className="game-btn reset-btn">
            Reset Game
          </button>
        )}
      </div>
    </div>
  );
};

export default TicTacToeGame;

